import { render } from "./EvaluationForm.vue?vue&type=template&id=2af3c0f4&scoped=true"
import script from "./EvaluationForm.vue?vue&type=script&lang=js"
export * from "./EvaluationForm.vue?vue&type=script&lang=js"

import "./evaluation-form.scss?vue&type=style&index=0&id=2af3c0f4&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af3c0f4"]])

export default __exports__